import Vue from 'vue'
import { gsap } from 'gsap'

export default new Vue({
  data () {
    return {

    }
  },
  methods: {
    setBackgroundOpacityStart (target) {
      var tl = gsap.timeline()
      tl.set(target, { opacity: 0 })
    },
    setTitleTranslate (target) {
      var tl = gsap.timeline()
      tl.set(target, { titleTranslate: 1, titleOpacity: 0 })
    },
    setImageTranslate (target) {
      var tl = gsap.timeline()
      tl.set(target, { imageTranslate: 1, imageOpacity: 0 })
    },
    animateBackgroundOpacity (target) {
      var tl = gsap.timeline()
      tl.to(target, { opacity: 1, duration: 0.5 })
      return tl
    },
    reverseBackgroundOpacity (target) {
      var tl = gsap.timeline()
      tl.to(target, { opacity: 0, duration: 0.5 })
      return tl
    },
    animateTitleTranslate (target) {
      var tl = gsap.timeline()
      tl.to(target, { titleTranslate: 0, titleOpacity: 1, duration: 0.75 })
      return tl
    },
    reverseTitleTranslate (target) {
      var tl = gsap.timeline()
      tl.to(target, { titleTranslate: 1, titleOpacity: 0, duration: 0.5 })
      return tl
    },
    animateImageTranslate (target) {
      var tl = gsap.timeline()
      tl.to(target, { imageTranslate: 0, imageOpacity: 1, duration: 1 })
      return tl
    },
    reverseImageTranslate (target) {
      var tl = gsap.timeline()
      tl.to(target, { imageTranslate: 1, imageOpacity: 0, duration: 0.5 })
      return tl
    },
    masterAnimate () {
      var tl = gsap.timeline()
      tl.add(this.animateBackgroundOpacity(this.slide))
      tl.add(this.animateTitleTranslate(this.slide), '<')
      tl.add(this.animateImageTranslate(this.slide), '-=0.5')
    },
    reverseAnimation () {
      return new Promise((resolve, reject) => {
        var tl = gsap.timeline({ onComplete: () => { resolve() } })
        tl.timeScale(1.6)
        tl.add(this.reverseTitleTranslate(this.slide))
        tl.add(this.reverseImageTranslate(this.slide), '-=0.4')
        tl.add(this.reverseBackgroundOpacity(this.slide), '-=0.4')
      })
    },
    registerComponent (name, component) {
      return new Promise((resolve, reject) => {
        this[name] = component
        // Set defaults:
        var tl = gsap.timeline()
        switch (name) {
          case 'slide':
            tl.add(this.setBackgroundOpacityStart(this.slide))
            tl.add(this.setTitleTranslate(this.slide))
            tl.add(this.setImageTranslate(this.slide))
            break

          default:
            break
        }
        if (
          this.slide
        ) {
          this.masterAnimate()
          resolve()
        }
      })
    }
  }
})
